import axios from "axios";
import { sortArrByName } from "../helpers/arrayHandlers";

export const getAllFirmwaresAPI = async () => {
  let response = await axios({
    url: `/api/v2/admin-utility/firmwares`,
    method: "GET"
  });
  const allFirmwareNames = response.data.firmwares;
  const sortedFirmwareNameArr = sortArrByName(allFirmwareNames);
  return sortedFirmwareNameArr;
};
